import { change } from 'redux-form';
import {
    CHECKOUT_FORM_NAME,
    DEFAULT_SELECTED_FORM_VALUE_FOR_SUBQUESTIONS,
} from '../constants';
import {
    BUYER_TAX_INVOICE,
    CANNED_QUESTION_TAX_INVOICE,
} from '../containers/checkout/constants';
import { SELECTED_QUESTION_GROUP_BUYER } from '../models/survey';
import { getInteractiveQuestionsByAttendeeId } from '../selectors/survey';

export const initializeTaxesSurveyQuestions = () => (dispatch, getState) => {
    const state = getState();
    const interactiveQuestionsByAttendeeId =
        getInteractiveQuestionsByAttendeeId(state);
    const buyerQuestions =
        interactiveQuestionsByAttendeeId[SELECTED_QUESTION_GROUP_BUYER] ?? [];
    const hasCannedQuestionTaxInvoice = buyerQuestions.find(
        ({ questionId }) => questionId === CANNED_QUESTION_TAX_INVOICE,
    );

    if (!hasCannedQuestionTaxInvoice) {
        return;
    }

    dispatch(
        change(
            CHECKOUT_FORM_NAME,
            BUYER_TAX_INVOICE,
            DEFAULT_SELECTED_FORM_VALUE_FOR_SUBQUESTIONS,
        ),
    );
};
